// src/pages/Changelog.js
import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import '../styles.css';

export default function Changelog() {
  return (
    <>
      <PublicHeader />
      <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '10px' }}>Changelog</h1>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '50px' }}>
          Stay updated with the latest features, improvements, and fixes in Hot Setup
        </p>

        <div className="changelog-timeline">
          <div className="changelog-entry">
            <div className="changelog-version">
              <h2>Tools update</h2>
              <span className="changelog-date">September 27, 2026</span>
            </div>
            <div className="changelog-content">
              <h3>🛠️ Calculators are now Tools</h3>
              <p>
                The Calculators section has been rebuilt as Tools, with a new layout and the ability to import values
                straight from your vehicles and sessions.
              </p>

              <h4>✨ What's New</h4>
              <ul>
                <li><strong>Import from vehicle:</strong> Every tool can pull values from a vehicle's saved setup or any session, with smart name matching that suggests the right parameters</li>
                <li><strong>Suspension Kinematics:</strong> 3D double wishbone, dual lower ball joint, 5-link and MacPherson solver with bump, roll about the roll centre, front/rear views, and roll centre, camber, bump steer and ride height charts</li>
                <li><strong>Battery Sizing:</strong> Size an EV race pack from power, regen and energy use, with I²R heating and an air or liquid cooling model</li>
                <li><strong>Redesigned tools:</strong> Brake Bias, Tire Size, Alignment and Wheel Rate have a new layout with sliders, typed inputs and unit toggles</li>
              </ul>
            </div>
          </div>

          <div className="changelog-entry">
            <div className="changelog-version">
              <h2>v1.0.0</h2>
              <span className="changelog-date">February 6, 2026</span>
            </div>
            <div className="changelog-content">
              <h3>🚀 Initial Release</h3>
              <p>
                Hot Setup is now live! This is the first version of our motorsport setup tracking app,
                built to help track-day enthusiasts and racers manage their vehicle setups more effectively.
              </p>

              <h4>✨ What's Included</h4>
              <ul>
                <li><strong>Vehicle Setup Tracking:</strong> Log all your suspension, aero, tires, and gearing changes between sessions</li>
                <li><strong>Session Data:</strong> Record lap times, weather conditions, and notes for each track session</li>
                <li><strong>Calculators:</strong> Built-in tools for brake bias, wheel rates, motion ratios, tire sizes, and alignment angles</li>
                <li><strong>Cloud Sync:</strong> Access your data from any device, with offline support</li>
                <li><strong>Setup History:</strong> Compare different setups and export your data</li>
              </ul>

              <h4>🔄 Future Updates</h4>
              <p>
                This changelog will be updated with each new version, detailing what changed and any new features.
                We're actively working on improvements based on user feedback, so expect regular updates with bug fixes
                and new capabilities.
              </p>

              <div className="changelog-note">
                <em>Thanks for trying Hot Setup! If you have suggestions or run into any issues,
                we'd love to hear from you.</em>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '60px', padding: '30px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <h3>Want to Suggest a Feature?</h3>
          <p>We're constantly evolving Hot Setup based on user feedback. Have an idea that could revolutionize motorsport setup tracking?</p>
          <a href="mailto:hello@hotsetup.app" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}>
            Share Your Vision →
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
}